var React = require('react');

function IconArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M8.8 20.18a17.44 17.44 0 0 1 8.38-8.31A17.48 17.48 0 0 1 8.8 3.56l-1.36.62a18.46 18.46 0 0 0 7.57 7.69 12.68 12.68 0 0 0-1.7 1 19 19 0 0 0-5.87 6.68l1.36.63z","fill":"#000","fillRule":"nonzero","key":1})]));
}

IconArrowInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowInline;

IconArrowInline.default = IconArrowInline;
